<template>
  <div id="adminCrmCities">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ crm }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ cities }}</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
      <h1>Comuni</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content">
          <div class="tab-pane active" id="tabTable" role="tabpanel">
                  <div class="row align-btns" style="width:85%;">
                    <div class="col-lg-6">
                      <button id="btnAdd" type="button" class="btn btn-primary" @click="onClickNew">
                        <i class="fa fa-plus"></i>
                        <span>{{ add }}</span>
                      </button>
                    </div>
                    <div class="col-3 text-left">
                      <select2
                        id="select_AdminPagesView_IdLanguage"
                        ref="select_AdminPagesView_IdLanguage"
                        class="form-control nopadding"
                        style="width:75%"
                        :filterable="false"
                        service="languages"
                        v-model="
                    pageValueSelected.languagePageSetting.idLanguage
                  "
                        :default="defaultLanguageOptions"
                        :change="languageChange"
                      />
                      <span style="margin-left:10px;">{{ language }}</span>
                    </div>
                  </div>
            <div class="card-body" style="padding:0px;">
              <bootstrapTable
                :configurations="TableCitiesConfiguration"
                :datas="tableData"
                id="tableCities"
                ref="tableCities"
                :onCheck="onTableCheck"
                :results="tableCitiesResult"
              ></bootstrapTable>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabCitiesDetail" role="tabpanel">
             <div class="card-body" style="padding:30px;">
              <div class="row">
               <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                <pageDetail
                  functions="AdminSettingCities"
                  :configurations="DetailCitiesConfiguration"
                  :jsonValue="detailCitiesData"
                ></pageDetail>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="cancelNewCities"
                  ><i class="fa fa-times"></i>{{ cancel }}</button>
                  <button type="button" class="btn btn-success" @click="saveNewCities"><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import Select2 from "@/components/Select2.vue";
import PageDetail from "@/components/PageDetail.vue";
export default {
  name: "adminCrmCities",
  components: {
    BootstrapTable,
    Select2,
    PageDetail,
  },
  data: function () {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      save: dictionaryHelpers.getDictionary("Save"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      cities: dictionaryHelpers.getDictionary("Cities"),
      language: dictionaryHelpers.getDictionary("Language"),
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      defaultLanguageOptions: [],
      tableCitiesResult: [],
      TableCitiesConfiguration: [],
      DetailCitiesConfiguration: [],
      detailCitiesData: {},
      rowIdSelected:0,
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null },
      },
      tableData: [],
      disableButton: true,
      url: window.location.pathname,
    };
  },
  created() {
    var adminCrmCities = this;

    spinnerHelpers.show();
    adminCrmCities.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage(),
    };

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function (result) {
      adminCrmCities.TableCitiesConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
           adminCrmCities.DetailCitiesConfiguration =
        result.data.tabsConfigurations[0].pageConfigurations;

      adminCrmCities.loadTable();
    });
  },
  methods: {
    loadTable(ln) {
      var adminCrmCities = this;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }

      citiesServices.getAll(ln, function (result) {
        adminCrmCities.tableData = result.data;
        spinnerHelpers.hide();
      });
    },
    onTableCheck() {
      var countRowSelected = this.$refs.tableCities.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminCrmCities = this;
      adminCrmCities.loadTable(value);
      spinnerHelpers.hide();
    },
    CityFormatter(value, row, index, field) {
      var adminCrmCities = this;
      var html = "";
      html +=
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      html +=
        '<button class="btn btn-success" onclick="adminCrmCities.__vue__.viewDatailInfo(' +
        row.id +
        ')"><i class="fa fa-pencil"/></button>';
      html +=
        '<button class="btn btn-danger" onclick="adminCrmCities.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';

      html += "</div>";
      return html;
    },
    viewDatailInfo(id) {
      spinnerHelpers.show();
      var adminCrmCities = this;
      this.rowIdSelected = id; 

      $.each(this.tableData, function (i, row) {
        if (adminCrmCities.rowIdSelected == row.id) {
          adminCrmCities.detailCitiesData = row;
        }
      });

      $("#tabTable").removeClass("active");
      $("#tabCitiesDetail").addClass("active");
      spinnerHelpers.hide();
    },
    delete(id) {
      var adminCrmCities = this;
      spinnerHelpers.show();
      citiesServices.del(id, function () {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
        var ln =
          adminCrmCities.pageValueSelected.languagePageSetting.idLanguage;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmCities.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },
    onClickNew() {
      spinnerHelpers.show();
      this.detailCitiesData = {};
      this.rowIdSelected="";
      $("#tabTable").removeClass("active");
      $("#tabCitiesDetail").addClass("active");
      spinnerHelpers.hide();
    },
    cancelNewCities() {
      spinnerHelpers.show();
      this.detailCitiesData = {};
      $("#tabTable").addClass("active");
      $("#tabCitiesDetail").removeClass("active");
      spinnerHelpers.hide();
    },
    saveNewCities() {
      spinnerHelpers.show();
      var adminCrmCities = this;
      this.detailCitiesData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0
      ) {
        this.detailCitiesData.id = this.rowIdSelected;

        citiesServices.update(this.detailCitiesData, function (result) {
          notificationHelpers.success(adminCrmCities.updateCompleted);
          adminCrmCities.loadTable();
          $("#tabTable").addClass("active");
          $("#tabCitiesDetail").removeClass("active");
        });
      } else {
        citiesServices.insert(this.detailCitiesData, function (result) {
          notificationHelpers.success(adminCrmCities.insertCompleted);
          adminCrmCities.loadTable();
          $("#tabTable").addClass("active");
          $("#tabCitiesDetail").removeClass("active");
        });
      }
    },
  },
};
</script>
<style scoped>
.card-title-admin .card {
  background: transparent;
  border: 0px;
}
.card-title-admin h1 {
  font-size: 40px;
  font-weight: lighter;
  color: #303c54;
}
.align-btns {
    position: absolute;
    z-index: 1;
    margin-top: 10px;
}
.span {
  position: absolute;
  margin-top: 75px;
}
</style>
